<div class="d-flex nav-item justify-content-center" (click)="handleClick()">
    <div class="d-flex flex-column justify-content-center align-items-center">
        <ng-content></ng-content>
        <span class="font-3 label">{{ label() }}</span>
    </div>
    @if(!hideChevronRight()){
       <div class="mt-2 ms-auto me-2">
        <chevron-right-icon />
       </div>
    }
    
</div>
